import {
  CbColorBackgroundInteractiveMainBase,
  CbColorPrimitiveWhite,
  CbShadowNone
} from '@coolblue-development/design-tokens';
import { Chip, freddyTheme } from '@coolblue-development/freddy';
import { SmileHappy } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';

export const InternalChip = () => {
  const { t } = useTranslation('filterPage.filterFacets');
  return (
    <Chip
      startIcon={<SmileHappy fill={freddyTheme.color.icon.contrast} />}
      sx={{
        backgroundColor: CbColorBackgroundInteractiveMainBase,
        color: CbColorPrimitiveWhite,
        borderColor: CbColorBackgroundInteractiveMainBase,
        boxShadow: CbShadowNone
      }}
    >
      {t('visibility.label')}
    </Chip>
  );
};
